<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <h1>Restore {{ capitalizeFirstLetter(type) }} </h1>
        <div class="search">
            <div class="button-right">
                <button class="btn-add"  @click="back()">
                    Back to {{ capitalizeFirstLetter(type) }}
                </button>
            </div>
        </div>
        <div class="section-list">
          <ul class="main-post">
            <li class="list-post list--post btm-margin">
              <p>Title</p>
              <p>Author</p>
              <p>Date</p>
            </li>
            <div class="list-post__item">
              <li class="list-post list--post" v-for="(data,index) in listData" :key="index">
                <div class="list-post__title">
                  <p>{{type === 'document' ? data.doc_name : data.title }}</p>
                  <button class="button" @click="resData(data)">Restore</button>
                  <button class="button hov-del" @click="delResData(data)">Delete</button>
                </div>
                <!-- <div>
                  <p>{{ data.desc }}</p>
                </div> -->
                <div> 
                  <p class="main-post__author">Admin</p>
                  <p class="main-post__email">{{ data.email }}</p>
                </div>
                <p class="main-post__date">{{ formatDate(data.dtm_upd.Time) }}</p>
              </li>
            </div>
          </ul>
          <paginate
            :page-range="3"
            :page-count="totalPages"
            :margin-pages="2"
            :click-handler="changePageNum"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from './../components/Loader.vue';
import alert from './../commons/alert.helper';
import moment from 'moment';
import axios from 'axios';

export default {
  name: 'RestorePost',
  data () {
    return {
      id: '',
      pageNum: 1,
      totalPages: 0,
      cat_id: '',
      listData: [],
      date: '',
      limit: 10,
      isLoading: false,
    }
  },
  methods: {
    // pagination
    changePageNum(val) {
      this.pageNum = val
      if (this.type === 'berita') {
        this.getListNews( )
      }
    },
    formatDate (val) {
        return moment(val).format('DD-MM-YYYY hh:mm:ss')
    },
    // Input Method Restored Here
    resData(data) {
      if (this.type === 'berita') {
        this.resDataNews(data.news_id)
      } else if (this.type === 'event') {
        this.resDataEvent(data.event_id)
      }
      else if (this.type === 'document') {
        this.resDataDocument(data.doc_id)
      }
    },
    // Input Method Delete Here
    delResData(data) {
      if (this.type === 'berita') {
        this.delDataNews(data.news_id)
      } else if (this.type === 'event') {
        this.delDataEvent(data.event_id)
      } else if (this.type === 'document') {
        this.delDataDocument(data.doc_id)
      }
    },
    back() {
      this.$router.go(-1)
    },
    async getListNews() {
      this.isLoading = true
      try {
        const response = await axios.get('/content/listnews' , {
          params: {
            // featured: this.featured,
            // cat_id: this.cat_id,
            page: this.pageNum,
            limit: this.limit
          }
        })
        console.log('list', response)

        this.listData = response.data.data
        // this.listData = response.data.data.filter(item => {
        //     return item.is_deleted.Bool == true
        // })
          
        this.totalPages = Math.ceil(response.data.meta.total_data / this.limit)
        console.log('dataList', this.listData)
        this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async getListEvent() {
      this.isLoading = true
      try {
        const response = await axios.get('/content/listevent')
        console.log(response)

        this.listData = response.data.data
        // this.listData = response.data.filter(item => {
        //     return item.is_deleted.Bool == true
        // })
          
        console.log('dataList', this.listData)
        this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async getListDocument() {
      this.isLoading = true
      try {
        const response = await axios.get('/member/listdocument')
        console.log(response)

        // this.listData = response.data
        this.listData = response.data.filter(item => {
            return item.is_deleted.Bool == true
        })
          
        console.log('dataList', this.listData)
        this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async delDataNews(id) {
      console.log('id', id)
      let self = this
      alert.confirmation( async function () {
        self.isLoading = true
        try {
            const response = await axios.delete(`/content/news/${id}`)
            self.isLoading = false
            console.log(response)
            alert.success('Delete data success', () => self.getListNews())
        } catch (error) {
            self.isLoading = false
            console.log(error)
            alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
    },
    async delDataEvent(id) {
      let self = this
      alert.confirmation( async function () {
          self.isLoading = true
          try {
              const response = await axios.delete(`/content/event/${id}`)
              self.isLoading = false
              console.log(response)
              alert.success('Delete data success', () => self.getListEvent())
          } catch (error) {
              self.isLoading = false
              console.log(error)
              alert.failed('Delete data failed')
          }
      }, 'Are you sure to delete it?')
    },
    async delDataDocument(id) {
      let self = this
      alert.confirmation( async function () {
          self.isLoading = true
          try {
              const response = await axios.delete(`/member/document/${id}`)
              self.isLoading = false
              console.log(response)
              alert.success('Delete data success', () => self.getListDocument())
          } catch (error) {
              self.isLoading = false
              console.log(error)
              alert.failed('Delete data failed')
          }
      }, 'Are you sure to delete it?')
    },
    async resDataNews(id) {
        console.log('resId', id)
        let self = this
        alert.confirmation( async function () {
        self.isLoading = true
            try {
                const response = await axios.patch(`/content/restorenews/${id}`)
                self.isLoading = false
                console.log(response)
                alert.success('Restore data success', () => self.getListNews())
            } catch (error) {
                self.isLoading = false
                console.log(error)
                alert.failed('Restore data failed')
            }
        }, 'Are you sure to restore this data?')
    },
    async resDataEvent(id) {
        console.log('resId', id)
        let self = this
        alert.confirmation( async function () {
        self.isLoading = true
            try {
                const response = await axios.patch(`/content/restoreevent/${id}`)
                self.isLoading = false
                console.log(response)
                alert.success('Restore data success', () => self.getListEvent())
            } catch (error) {
                self.isLoading = false
                console.log(error)
                alert.failed('Restore data failed')
            }
        }, 'Are you sure to restore this data?')
    },
    async resDataDocument(id) {
      let self = this
      alert.confirmation( async function () {
      self.isLoading = true
          try {
              const response = await axios.patch(`/member/restoredocument/${id}`)
              self.isLoading = false
              console.log(response)
              alert.success('Restore data success', () => self.getListDocument())
          } catch (error) {
              self.isLoading = false
              console.log(error)
              alert.failed('Restore data failed')
          }
      }, 'Are you sure to restore this data?')
    },
    
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
  components: {
    Loader
  },
  created() {
    // this.getListPerindo();
    this.type = this.$route.params.type
    if (this.type === 'berita') {
        this.getListNews()
    } else if (this.type === 'event') {
        this.getListEvent()
    } else if (this.type === 'document') {
        this.getListDocument()
    }
  }
}
</script>